import { render } from "./App.vue?vue&type=template&id=36e61c32"
const script = {}

import "./App.vue?vue&type=style&index=0&id=36e61c32&lang=scss"

import exportComponent from "C:\\projects 2022\\helmets-nepal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__